<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <b-img
          fluid
          :src="isEdit ? isEditParams.header_img : headerImg"
          class="header-img"
          alt="header"
        />
      </b-col>

      <b-col cols="12" class="body pb-5">
        <p>
          {{
            isEdit
              ? capitalizeText(isEditParams.current_city)
              : capitalizeText(petitioner.city)
          }},
          <span v-if="isEdit">
            {{ getDate | moment("D [de] MMMM [del] YYYY") }}
          </span>
          <span v-else>
            {{ createdAt | moment("D [de] MMMM [del] YYYY") }}
          </span>
        </p>
        <p>
          Sres.
          <br />
          <em class="text-bold">{{
            isEdit
              ? isEditParams.business_partner_society
              : businessPartner.society
          }}</em>
          <br />
          {{
            isEdit
              ? capitalizeText(isEditParams.business_partner_name)
              : capitalizeText(businessPartner.name)
          }}
          <br />
          {{
            isEdit ? isEditParams.business_partner_role : businessPartner.role
          }}
        </p>

        <p class="pt-4">Ref: Solicitud Permisos Sindicales</p>

        <p class="pt-4">Cordial saludo,</p>
        <p>
          {{
            isEdit
              ? capitalizeText(isEditParams.petitioner_name)
              : capitalizeText(petitioner.name)
          }}, en calidad de solicitante sindical de la organización sindical
          {{ isEdit ? isEditParams.labor_union : laborUnionName }}, teniendo en
          cuenta lo estipulado en la Covención Colectiva de Trabajo, me dirijo a
          ustedes con el fin de solicitar los siguientes permisos sindicales
          {{ textTickets }} tiquetes con motivo de
          {{
            isEdit
              ? isEditParams.motive
              : getLicenseGetter.reason
              ? `${getLicenseGetter.reason.toLowerCase().trim()}.`
              : null
          }}
          y con las siguientes especificaciones:
        </p>

        <div class="pt-4">
          <table-collaborator :fields="fields" :items="items" />
        </div>

        <p
          class="pt-4"
          v-if="
            isEdit ? isEditParams.additional_information : additionalInformation
          "
        >
          Información adicional importante para el permiso
          {{
            `${
              isEdit
                ? isEditParams.additional_information
                : additionalInformation
            }.`
          }}
        </p>

        <p class="pt-4">
          La solicitud presentada se fundamenta en el artículo 57 del código
          laboral, así como en los artículos 38 y 39 de la constitución política
          de Colombia, además de los artículos 353, 354, 405, 467, 468, y 475
          del CST. Asimismo, se respalda en los convenios 87 y 98 de la OIT.
        </p>

        <p class="pt4 body-thanks">Agradezco su atención y pronta respuesta.</p>

        <p class="pt-5">Cordialmente.</p>

        <table class="pb-3">
          <tr>
            <td align="center">
              <img
                width="150"
                height="50"
                align="center"
                :src="
                  isEdit
                    ? isEditParams.template_signature_one
                    : templateLicense.signature_one
                "
                alt="signature-presidente"
              />
              <hr width="150" />
              <p>
                {{
                  isEdit
                    ? capitalizeText(isEditParams.template_name_one)
                    : capitalizeText(templateLicense.name_one)
                }}
                <br />
                {{
                  isEdit
                    ? isEditParams.template_position_one
                    : templateLicense.position_one
                }}
              </p>
            </td>
            <td align="center">
              <img
                width="150"
                height="50"
                align="center"
                :src="
                  isEdit
                    ? isEditParams.template_signature_two
                    : templateLicense.signature_two
                "
                alt="signature-secretario"
              />
              <hr width="150" />
              <p>
                {{
                  isEdit
                    ? capitalizeText(isEditParams.template_name_two)
                    : capitalizeText(templateLicense.name_two)
                }}
                <br />
                {{
                  isEdit
                    ? isEditParams.template_position_two
                    : templateLicense.position_two
                }}
              </p>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<style lang="scss" src="./styles.scss" />
